<template>
    <div class="autocomplete-menu">
      <md-field class="md-field md-theme-default" md-menu-trigger>
        <label>{{ label }}</label>
        <md-input class="md-input" v-model="searchKey" type="text" v-on:keyup="search"/>
      </md-field>
      <md-list class="autocomplete-menu-content md-scrollbar" v-if="$store.state.receivedData[stateObject].list.length > 0 && menuVisible">
        <md-list-item class="md-button-clean" v-for="option in $store.state.receivedData[stateObject].list" v-on:click="onSelect(option)">
          {{ option[searchBy] }} <b>{{ option[additionalField] }}</b>
        </md-list-item>
      </md-list>
    </div>
</template>

<script>
export default {
  name: 'Autocomplete',
  props: ['stateObject', 'label', 'searchBy', 'returnField', 'getValue', 'additionalField'],

  data(){
    return{
      searchKey: '',
      menuVisible: false,
    }
  },

  created(){
    if(this.getValue != '' && this.getValue !== undefined){
      this.searchKey = this.getValue;
    }
  },

  methods:{
    onSelect(option){
      this.searchKey = option[this.searchBy];
      let returnField = this.returnField !== undefined ? option[this.returnField] : option;
      this.$emit('input', returnField);
      this.menuVisible = false;
    },

    search(){
      if(!this.menuVisible) this.menuVisible = true;
      clearTimeout(this.timeout);
      if(this.searchKey.length > 1) this.$store.state.loading = true;
      else this.$store.state.receivedData[this.stateObject].list = [];
      this.timeout = setTimeout(async () => {
        if(this.searchKey != '' && this.searchKey.length > 1) await this.$store.dispatch('getSearchedData', {filter: this.searchKey, stateObject:this.stateObject})
        this.$store.state.loading = false;
      }, 1000);
    }
  },
}
</script>

<style lang="scss">
.autocomplete-menu{
  position: relative;
  margin-bottom: 24px;
  display: block;
  width: 100%;
  z-index: 9999;

  .md-field{
    margin-bottom: 1px;
  }

  .md-button-clean{
    overflow: visible !important;
  }
}

.autocomplete-menu-content{
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  transform: translateY(100%);
  padding: 0;
  overflow-y: scroll;
  max-height: 400px;
  box-shadow: 0 5px 5px -3px rgba(0,0,0,.2), 0 8px 10px 1px rgba(0,0,0,.14), 0 3px 14px 2px rgba(0,0,0,.12);
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Autocomplete.vue